import { render, staticRenderFns } from "./AggregateSetting.vue?vue&type=template&id=0391592b&"
import script from "./AggregateSetting.vue?vue&type=script&lang=js&"
export * from "./AggregateSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports